import { render, staticRenderFns } from "./ViewAssociation.vue?vue&type=template&id=564953ad&"
import script from "./ViewAssociation.vue?vue&type=script&lang=js&"
export * from "./ViewAssociation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports